module.exports = __webpack_public_path__ + "img/first-picture.f581d808.png";